'use strict';

export class GetElement {
    #element
    constructor(selector) {
        this.#element = document.querySelector(selector);
    }

    get width() {
        if (!this.#element)
            return 0;

        return this.#element.getBoundingClientRect().width;
    }
}